module.exports = __webpack_public_path__ + "static/media/vi-data-roaming-other_4.e4507748.png";